import { useState } from "react";
import axios from "./axios";
import { toast } from "sonner";

export const useGenerateBrand = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const generateBrand = async ({
    token,
    route,
    is_link,
    brand_id,
    user_id,
  }) => {
    try {
      setLoading(true);
      const res = await axios.post(
        `/audiences/world-game${route ? route : ""}`,
        JSON.stringify({
          brand_id,
          is_link,
          user_id,
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setLoading(false);
        setData(res.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.message);
      setData(null);
    }
  };

  return { generateBrand, data, setData, loading, setLoading };
};
